/**
* @file 机构名称-合作信息
* */
<template>
  <div id="cooperateInfo">
    <h2 style="margin-bottom: 20px">添加（{{ organizationName }}）合作信息</h2>
    <div name="formBasic">
      <!-- 机构信息 -->
      <el-row type="flex" align="middle">
        <el-col :span="22">
          <div class="formTitle">机构主体信息</div>
        </el-col>
        <el-col :span="2" style="text-align: right">
          <el-button
            type="primary"
            v-show="!editBasic"
            @click="formEdit(true, 'formBasic', 'editBasic', 'basicForm')"
          >
            编辑
          </el-button>
        </el-col>
      </el-row>

      <el-form
        :model="formBasic"
        :rules="rulesBasic"
        ref="formBasic"
        :disabled="!editBasic"
        label-position="left"
        label-width="150px"
      >
        <el-row>
          <el-col :span="11">
            <el-form-item label="主体名称" prop="principalName">
              <el-input
                v-model="formBasic.principalName"
                maxlength="50"
                placeholder="请输入机构主体名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="社会信用代码" prop="identifier">
              <el-input
                v-model="formBasic.identifier"
                maxlength="18"
                placeholder="请输入社会信用代码"
              ></el-input>
            </el-form-item>
            <el-form-item label="法人姓名" prop="legalName">
              <el-input
                v-model="formBasic.legalName"
                maxlength="10"
                placeholder="请输入法人姓名"
              ></el-input>
            </el-form-item>
            <el-form-item label="法人身份证号" prop="legalIdCard">
              <el-input
                v-model="formBasic.legalIdCard"
                maxlength="18"
                placeholder="请输入法人身份证号"
              ></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="legalPhone">
              <el-input
                v-model="formBasic.legalPhone"
                maxlength="12"
                placeholder="请输入联系电话"
              ></el-input>
            </el-form-item>
            <el-form-item label="电子邮箱" prop="emailAddress">
              <el-input
                v-model="formBasic.emailAddress"
                maxlength="50"
                placeholder="请输入电子邮箱"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11" :push="2">
            <el-form-item label="营业执照" prop="identifierPhoto">
              <up-img
                :disabled="!editBasic"
                :file.sync="formBasic.identifierPhoto"
                width="220"
                height="122"
              ></up-img>
            </el-form-item>
            <el-form-item
              label="增值电信业务经营许可证"
              prop="vatsoLicensePhoto"
            >
              <up-img
                :disabled="!editBasic"
                :file.sync="formBasic.vatsoLicensePhoto"
                width="220"
                height="122"
              ></up-img>
            </el-form-item>
          </el-col>
        </el-row>

        <el-col :span="22">
          <div class="formTitle">机构合作模式</div>
        </el-col>

        <el-row>
          <el-col :span="11">
            <el-form-item
              label="平台抽佣"
              prop="cooperationRatio"
            >
              <el-input
                v-model="formBasic.cooperationRatio"
                maxlength="10"
                placeholder="请输入平台抽佣比例"
                @input="ratioInput($event, 'cooperationRatio')"
              >
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
            <el-form-item
              label="平台返佣"
              prop="rebateRatio"
            >
              <el-input
                v-model="formBasic.rebateRatio"
                maxlength="10"
                placeholder="请输入平台返佣比例"
                @input="ratioInput($event, 'rebateRatio')"
              >
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
            <el-form-item label="保证金" prop="earnestMoney">
              <el-input
                v-model="formBasic.earnestMoney"
                maxlength="9"
                placeholder="请输入保证金金额"
                @input="earnestInput"
              >
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11" :push="2">
            <el-form-item label="合作协议" prop="cooperationPhoto">
              <upload_pdfs
                :disabled="!editBasic"
                :max="1"
                @update:urls="updateUrls"
                :urls.sync="formBasic.cooperationPhoto"
              >
              </upload_pdfs>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row style="text-align: right; position: relative">
          <el-button
            v-show="editBasic"
            type="primary"
            @click="formSave('formBasic')"
            :loading="loadingBasic"
          >
            保存
          </el-button>

          <el-button
            v-show="editBasic"
            @click="formEdit(false, 'formBasic', 'editBasic', 'basicForm')"
            :loading="loadingBasic"
          >
            取消
          </el-button>
        </el-row>
      </el-form>
      <!-- 机构运营区域 -->
      <el-row type="flex" align="middle">
        <el-col :span="22">
          <div class="formTitle">机构运营区域</div>
        </el-col>
        <el-col :span="2" style="text-align: right">
          <el-button
            type="primary"
            v-show="!editCity"
            @click="formEdit(true, 'formCity', 'editCity', 'cityForm')"
          >
            编辑
          </el-button>
        </el-col>
      </el-row>
      <el-form :model="formCity" ref="formCity" :disabled="!editCity">
        <el-form-item>
          <div class="menu">
            <div class="main-menu" v-for="(item, i) in cityCheckList" :key="i">
              <el-checkbox
                size="mini"
                v-model="item.check"
                :label="item.cityCode"
              >
                {{ item.cityName }}
              </el-checkbox>
            </div>
          </div>
        </el-form-item>

        <el-row style="text-align: right; position: relative">
          <el-button
            v-show="editCity"
            type="primary"
            @click="formSave('formCity')"
            :loading="loadingCity"
          >
            保存
          </el-button>

          <el-button
            v-show="editCity"
            @click="formEdit(false, 'formCity', 'editCity', 'cityForm')"
            :loading="loadingCity"
          >
            取消
          </el-button>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import upload_pdfs from "@/components/pdf/upload_pdfs";
export default {
  name: "cooperateInfo",
  components: {
    upload_pdfs,
  },
  data() {
    return {
      action: window.configure.qiniuUrl,
      // 判断原本是否有内容
      id: null,
      // 机构id
      organizationId: this.$route.query.id,
      organizationName: '',
      // 基本信息表单
      editBasic: false,
      formBasic: {},
      rulesBasic: {
        principalName: [{ required: true, message: "请输入主体名称" }],
        identifier: [{ required: true, message: "请输入社会信用代码" }],
        legalName: [{ required: true, message: "请输入法人姓名" }],
        legalIdCard: [
          { required: false, message: "请输入法人身份证号" },
          {
            pattern: /(^\d{15}$)|(^\d{17}(\d|X|x)$)/,
            message: "只能输入15-18位的身份证号",
          },
        ],
        legalPhone: [
          { required: true, message: "请输入联系电话" },
          {
            pattern: /^[0-9-]{7,12}$/,
            // /^1\d{10}$|^(0\d{2,3}-?|\(0\d{2,3}\))?[1-9]\d{4,7}(-\d{1,8})?$/,
            message: "请输入正确的联系电话",
          },
        ],
        identifierPhoto: [{ required: true, message: "请上传营业执照" }],
        cooperationRatio: [{ required: true, message: "请输入平台抽佣比例" }],
        rebateRatio: [{ required: true, message: "请输入平台返佣比例" }],
        cooperationPhoto: [{ required: true, message: "请上传合作协议" }],
        earnestMoney: [{ required: true, message: "请输入保证金金额" }],
      },
      // 保存按钮loading
      loadingBasic: false,
      cityCheckList: [],
      editCity: false,
      formCity: {},
      loadingCity: false,
    };
  },
  computed: {
    ...mapGetters({
      cityList: "cityListGetter",
    }),
  },
  async created() {
    await this.getPlatform();
    this.getCity();
  },
  watch: {
    editBasic: {
      handler(val, oldVal) {
        console.log('val::: ', val);
        if(val) {
          this.formBasic.cooperationRatio =  this.formBasic.cooperationRatio ? this.formBasic.cooperationRatio : 20
          this.formBasic.rebateRatio =  this.formBasic.rebateRatio ? this.formBasic.rebateRatio : 0
        }
        const notRequired = ["legalIdCard"];
        Object.keys(this.rulesBasic).forEach((key) => {
          if (!notRequired.includes(key)) {
            this.rulesBasic[key][0].required = val;
          }
        });
      },
      immediate: true,
    },
  },
  methods: {
    ratioInput(val, key) {
      if (!val && val !== 0) {
        this.formBasic[key] = val;
        return;
      }
      val = val.replace(/[^\d]/g, "");
      if (val > 100) {
        val = 100;
      }
      if (val < 0) {
        val = 0;
      }
      this.formBasic[key] = val;
    },
    earnestInput(val) {
      if (!val && val !== 0) {
        this.formBasic.earnestMoney = val;
        return;
      }
      val = val.replace(/[^\d]/g, "");
      if (val > 999999) {
        val = 999999;
      }
      if (val < 1) {
        val = 1;
      }
      this.formBasic.earnestMoney = val;
    },
    async getCity() {
      this.cityCheckList = this.cityList.map((item) => {
        return {
          ...item,
          check: this.formBasic.serviceCity
            ? this.formBasic.serviceCity.split(",").includes(item.cityCode)
            : false,
        };
      });
    },
    updateUrls() {
      this.$refs.formBasic.validateField("cooperationPhoto");
    },
    // type:编辑或者取消 formName:表单form editNumber:编辑下标 temporaryForm:临时form对象
    formEdit(type, formName, editNumber, temporaryForm) {
      if (type) {
        this[temporaryForm] = JSON.parse(JSON.stringify(this[formName]));
        this[editNumber] = true;
      } else {
        this.$refs[formName].resetFields();
        this[formName] = JSON.parse(JSON.stringify(this[temporaryForm]));
        this[editNumber] = false;
      }
    },

    /**
     * 点击保存
     */
    async formSave(formName) {
      switch (formName) {
        case "formBasic":
          this.$refs.formBasic.validate((valid) => {
            if (valid) {
              this.postFn();
            } else {
              this.$message.warning("请检查表单数据是否输入正确！");
            }
          });
          break;
        case "formCity":
          this.postCityFn();
          break;
        default:
          break;
      }
    },
    /**
     * 接口请求-基本信息保存
     */
    async postFn() {
      this.loadingBasic = true;
      let url = "/api/v1/manage/organization/hitchRide";
      let data = JSON.parse(JSON.stringify(this.formBasic));
      if (!data.organizationId) {
        data.organizationId = this.organizationId;
      }
      data.cooperationPhoto = data.cooperationPhoto[0].url;
      let res = await this.$axios.post(url, data);
      if (res && res.code === 1) {
        this.$message.success("保存成功！");
        this.editBasic = false;
        this.getPlatform();
      }
      this.loadingBasic = false;
    },

    async postCityFn() {
      this.loadingCity = true;
      let url = "/api/v1/manage/organization/hitchRide";
      let res = await this.$axios.post(url, {
        organizationId: this.organizationId,
        serviceCity: this.cityCheckList
          .filter((item) => item.check)
          .map((item) => item.cityCode)
          .join(","),
      });
      if (res && res.code === 1) {
        this.$message.success("保存成功！");
        this.editCity = false;
        this.getPlatform();
      }
      this.loadingCity = false;
    },

    async getPlatform() {
      let formBasicURL =
        "/api/v1/manage/organization/hitchRide/" + this.organizationId;
      const { code, data } = await this.$axios.get(formBasicURL);
      if (code === 1) {
        data.cooperationPhoto = data.cooperationPhoto
          ? [{ url: data.cooperationPhoto, name: data.cooperationPhoto }]
          : [];
        this.id = data.id || null;
        this.formBasic = data || {};
        this.getCity();
        this.organizationName = await this.getOrgName(this.organizationId)
      }
    },
  },
};
</script>

<style lang="less" scoped>
#cooperateInfo {
  padding-left: 40px;
  width: 1100px;
  .menu {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .main-menu {
      height: 30px;
      line-height: 30px;
      margin-right: 10px;
    }
  }
}
#cooperateInfo /deep/ .el-upload-dragger {
  width: 220px !important;
  height: 80px !important;
}
.el-upload__text {
  margin-top: 30px;
}
</style>
